// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"b0c310850c5ce447624d","71":"904eff6b60374bf53955","452":"09afb98ae6e1c4c327f4","885":"1de9a5c0533d81def980","961":"1e483cc5c3ed43565d3b"}[chunkId] + ".css";
};